import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../Pages/Footer';

const ServiceSupport = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const name = e.target.fullName.value;
    const phone = e.target.phone.value;
    const email = e.target.email.value;
    const address = e.target.address.value;
    const message = e.target.message.value;
    const facilityName = e.target.facilityName.value;
    const state = e.target.state.value;

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSfJo2fFdASSm2KsT10UiKU4x9riO4yMDEtw8Fq61oFQargNZw/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body:
            'entry.955316732=' +
            encodeURIComponent(name) +
            '&entry.752138582=' +
            encodeURIComponent(phone) +
            '&entry.473922086=' +
            encodeURIComponent(facilityName) +
            '&entry.1336175125=' +
            encodeURIComponent(email) +
            '&entry.1260820143=' +
            encodeURIComponent(state) +
            '&entry.298901513=' +
            encodeURIComponent(address) +
            '&entry.30191126=' +
            encodeURIComponent(message),
        }
      );

      alert('Appointment request submitted successfully!');
      e.target.reset();
    } catch (error) {
      alert('Error submitting form');
      console.error(error);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    boxSizing: 'border-box',
    fontFamily: 'sans-serif',
    color: '#333',
    background: '#fff',
    marginTop: '6px',
  };

  const labelStyle = {
    fontSize: '13px',
    fontWeight: '600',
    color: '#333',
    display: 'block',
    marginBottom: '2px',
  };

  return (
    <>
      <Helmet>
        <title>
          Service Support | Medical Equipment Support by Mindron Meditech
        </title>
        <meta
          name="description"
          content="Get service support from Mindron Meditech for medical equipment, diagnostic devices, installation assistance, product guidance, maintenance, troubleshooting, and healthcare technology support."
        />
        <link
          rel="canonical"
          href="https://www.mindronmeditech.com/servicesupport"
        />
      </Helmet>

      <div
        style={{
          fontFamily: 'sans-serif',
          overflowX: 'hidden',
          color: '#222',
        }}
      >
        {/* HERO BANNER */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: isMobile ? '220px' : '550px',
            overflow: 'hidden',
            margin: '0',
          }}
        >
          <img
            src={require('../Images/support.jpeg')}
            alt="Service & Support"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
            }}
          />

          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(to right, rgba(0,20,60,0.7) 40%, transparent 100%)',
            }}
          />

          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: isMobile ? '5%' : '4%',
              transform: 'translateY(-50%)',
              color: '#fff',
              maxWidth: isMobile ? '80%' : '40%',
              zIndex: 2,
            }}
          >
            <h2
              style={{
                fontSize: isMobile ? '20px' : '48px',
                fontWeight: '800',
                margin: isMobile ? '40px 0 12px' : '0 0 12px',
                lineHeight: 1.2,
              }}
            >
              Service & <span style={{ color: '#ff4444' }}>Support</span>
            </h2>

            {!isMobile && (
              <p
                style={{
                  fontSize: '20px',
                  lineHeight: '1.7',
                  margin: 0,
                  color: '#dde',
                }}
              >
                From setup to seamless operation, Mindron Meditech Pvt. Ltd.
                ensures dependable service and consistent performance across
                every stage.
              </p>
            )}
          </div>
        </div>

        {/* MEDITECH SERVICE SECTION */}
        <div style={{ padding: isMobile ? '32px 6%' : '48px 6%' }}>
          <div
            style={{
              width: '120px',
              height: '3px',
              backgroundColor: '#cc0000',
              borderRadius: '2px',
              marginBottom: '8px',
            }}
          />

          <h2
            style={{
              fontSize: isMobile ? '20px' : '24px',
              fontWeight: '800',
              color: '#0a1628',
              margin: '0 0 16px',
              display: 'inline-block',
              paddingBottom: '4px',
            }}
          >
            Meditech Service
          </h2>

          <p
            data-aos="fade-up"
            style={{
              fontSize: '15px',
              color: '#555',
              lineHeight: '1.8',
              maxWidth: '800px',
              margin: 0,
            }}
          >
            At Mindron Meditech Pvt. Ltd., our service solutions are built
            around performance, reliability, and trust. Our dedicated team of
            engineers delivers comprehensive support — from installation to
            advanced troubleshooting — ensuring your systems operate smoothly at
            all times. With proactive maintenance strategies, we reduce
            downtime, optimize efficiency, and extend equipment lifespan.
          </p>
        </div>

        {/* CONTACT FORM */}
        <div
          style={{
            padding: isMobile ? '32px 6%' : '48px 8%',
            background: '#f7f9fc',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <h2
              style={{
                fontSize: isMobile ? '20px' : '26px',
                fontWeight: '800',
                color: '#0a1628',
                margin: '0 0 8px',
              }}
            >
              Meditech Service Contact Form
            </h2>

            <p
              style={{
                fontSize: '15px',
                fontWeight: '600',
                color: '#0a1628',
                margin: '0 0 4px',
              }}
            >
              Book your appointment now
            </p>

            <p
              style={{
                fontSize: '13px',
                color: '#888',
                margin: 0,
              }}
            >
              So our team can reach out to you on time
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            style={{
              maxWidth: '700px',
              margin: '0 auto',
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: '16px',
              }}
            >
              <div>
                <label style={labelStyle}>Full Name</label>
                <input
                  name="fullName"
                  type="text"
                  placeholder="Full Name"
                  style={inputStyle}
                  required
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(
                      /[^A-Za-z\s]/g,
                      ''
                    );
                  }}
                />
              </div>

              <div style={{ gridRow: isMobile ? 'auto' : 'span 3' }}>
                <label style={labelStyle}>Share Your Message</label>
                <textarea
                  name="message"
                  placeholder="Message"
                  style={{
                    ...inputStyle,
                    height: isMobile ? '100px' : '218px',
                    resize: 'vertical',
                  }}
                  required
                />
              </div>

              <div>
                <label style={labelStyle}>Phone Number</label>
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    marginTop: '6px',
                  }}
                >
                  <select
                    style={{
                      ...inputStyle,
                      width: '75px',
                      flexShrink: 0,
                      marginTop: 0,
                    }}
                  >
                    <option>+91</option>
                    <option>+1</option>
                    <option>+44</option>
                    <option>+852</option>
                  </select>

                  <input
                    name="phone"
                    type="tel"
                    placeholder="Phone Number"
                    style={{ ...inputStyle, marginTop: 0 }}
                    required
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, '')
                        .slice(0, 10);
                    }}
                  />
                </div>
              </div>

              <div>
                <label style={labelStyle}>Facility Name*</label>
                <input
                  name="facilityName"
                  type="text"
                  placeholder="Facility Name"
                  style={inputStyle}
                  required
                />
              </div>

              <div>
                <label style={labelStyle}>Email</label>
                <input
                  name="email"
                  type="email"
                  placeholder="Email Address"
                  style={inputStyle}
                  required
                />
              </div>

              <div>
                <label style={labelStyle}>State*</label>
                <input
                  name="state"
                  type="text"
                  placeholder="State"
                  style={inputStyle}
                  required
                />
              </div>

              <div>
                <label style={labelStyle}>Address</label>
                <input
                  name="address"
                  type="text"
                  placeholder="Your Address"
                  style={inputStyle}
                />
              </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '28px' }}>
              <button
                type="submit"
                style={{
                  padding: '12px 80px',
                  fontSize: '15px',
                  fontWeight: '700',
                  backgroundColor: '#001F54',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#003399';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#001F54';
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>

        <Footer />

        <style>{`
          *::-webkit-scrollbar {
            display: none;
          }

          * {
            scrollbar-width: none;
          }

          body {
            overflow-x: hidden;
          }

          input:focus,
          textarea:focus,
          select:focus {
            outline: 2px solid #001F54;
            border-color: #001F54;
          }
        `}</style>
      </div>
    </>
  );
};

export default ServiceSupport;